import { useLocation } from "react-router-dom";
import TopContentCampaign from "../../components/user/Campaign/CampaignContentComponents/TopContentCampaign";
import MiddleContentCampaign from "../../components/user/Campaign/CampaignContentComponents/MiddleContentCampaign";
import LastContentCampaign from "../../components/user/Campaign/CampaignContentComponents/LastContentCampaign";
import { useState } from "react";
import ItineraryContentCampaign from "../../components/user/Campaign/CampaignContentComponents/ItineraryContentCampaign";

const AdminCampaignDetails = () => {
  const { state } = useLocation();
  const [campaign, setCampaign] = useState(state?.campaign);
  console.log("state.campaign", state.campaign);
  if (!campaign) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-gray-600">
        No campaign data provided
      </div>
    );
  }

  return (
    <div className="flex flex-col lg:flex-row w-full justify-center items-start md:py-6 gap-5 md:px-[3.5rem] px-4 py-4">
      {/* Left Content - Campaign Preview */}
      <div className="w-full  order-1">
        <TopContentCampaign
          banner_images={campaign.images}
          title={campaign.name}
          description={campaign.description}
          location={campaign.location}
          date={campaign.date}
        />
        <ItineraryContentCampaign itinerary={campaign?.itinerary} />
        <MiddleContentCampaign shortInfo={campaign.shortInfo} />
        <LastContentCampaign campaign={campaign} />
      </div>
    </div>
  );
};

export default AdminCampaignDetails;
